<app-tabela
 [title]='title'
 [Service]='service'
   [displayedColumns]='displayedColumns'
   [columnsToDisplay]='columnsToDisplay'
   [columnsBadge]='columnsBadge'
   [novo]='novo'
   [columnsObject]='columnsObject'
   [columnsObject2]='columnsObject2'
   [columnsObject3]='columnsObject3'
    [options]='options'
    [events]="eventsSubject.asObservable()"
     [view]='view'
     [edit]='edit'
     [changeStatus]='changeStatus'
     [delete]='delete'
     ></app-tabela>
